import { useState } from 'react';
import { NavDropdown } from 'react-bootstrap';

const NavHoverDropdown = (props) => {
  const {
    id,
    title,
    menuVariant,
    renderMenuOnMount,
    children,
    delay,
    className,
    onClick,
  } = props;
  const [show, setShow] = useState(false);
  const dropdownDelay = delay || 300;
  const showDropdown = () => {
    setShow(!show);
  };
  const hideDropdown = () => {
    setTimeout(() => {
      setShow(false);
    }, dropdownDelay);
  };

  return (
    <NavDropdown
      id={id}
      title={title}
      menuVariant={menuVariant}
      show={show}
      renderMenuOnMount={renderMenuOnMount}
      onMouseEnter={showDropdown}
      onMouseLeave={hideDropdown}
      className={className}
      onClick={onClick}
    >
      {children}
    </NavDropdown>
  );
};

export default NavHoverDropdown;
